import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AutoComplete from 'material-ui/AutoComplete';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

import { setUserToBlackList } from 'actions/users';

import api from 'services';
import styles from 'styles';

class BlackList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            blackList: [],
            emails: [],
            searchText: '',

            filteredList: [],
            filterText: '',
        };

        this.onUpdateInput = this.onUpdateInput.bind(this);

        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);

        this.onUpdateList = this.onUpdateList.bind(this);
        this.filterList = this.filterList.bind(this);
    }

    filterList(value) {
        this.setState({
            filterText: value,
            filteredList: this.state.blackList.filter((item) => {
                return item.toLowerCase().includes(value.toLowerCase());
            }),
        });
    }

    onUpdateList() {
        if (this.props.selectedUser) {
            this.props.setUserToBlackList(this.state.blackList, this.props.selectedUser);
        }
    }

    addItem() {
        const { blackList, searchText } = this.state;

        if (searchText.length === 0) {
            return;
        }

        if (blackList.find((item) => searchText === item )) {
            return;
        }

        blackList.push(searchText);

        this.setState({
            blackList,
            emails: [],
            searchText: '',
            filteredList: blackList.filter((item) => {
                return item.toLowerCase().includes(this.state.filterText.toLowerCase());
            }),
        })
    }

    removeItem(email) {
        const { blackList } = this.state;

        blackList.splice(blackList.indexOf(email), 1);

        this.setState({
            blackList,
            filteredList: blackList.filter((item) => {
                return item.toLowerCase().includes(this.state.filterText.toLowerCase());
            }),
        })
    }

    onUpdateInput(searchText) {
        this.setState({
            searchText,
        }, () => {
            if (this.state.searchText.length <= 2) {
                return;
            }

            api.findUser(searchText, true)
                .then((response) => {
                    if (response.status === 200) {
                        const emails = response.data.data.map((item) => {
                            return item.email;
                        });

                        this.setState({
                            emails,
                        });
                    }
                });
        });
    }

    UNSAFE_componentWillReceiveProps({ selectedUser }) {
        if (!selectedUser) {
            return;
        }

        if (selectedUser.limitations) {
            const blackList = selectedUser.limitations.black.map((blackItem) => {
                return blackItem.email;
            });

            this.setState({
                blackList,
                filteredList: blackList.filter((item) => {
                    return item.toLowerCase().includes(this.state.filterText.toLowerCase());
                }),
            });
        } else {
            this.setState({
                blackList: [],
                emails: [],
                searchText: '',
                filteredList: [],
            });
        }
    }

    render() {
        const { filteredList, emails, searchText, filterText } = this.state;
        const { selectedUser } = this.props;

        if (!selectedUser) {
            return null;
        } else {
            return (<div className="paper-block" style={{ fontSize: '12px' }}>
                <span className="name-block absolute">Black list</span>
                <div className="row">
                    <div className="col-xs-12">
                        <TextField
                            floatingLabelText='Filter by substring'
                            style={{ fontSize: '13px' }}
                            value={filterText}
                            onChange={(e, value) => {
                                this.filterList(value);
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-10">
                        <AutoComplete
                            textFieldStyle={styles.autoCompleteCSS}
                            floatingLabelText='Email user'
                            searchText={searchText}
                            dataSource={emails}
                            onUpdateInput={(searchText) => {
                                this.onUpdateInput(searchText);
                            }}
                            filter={AutoComplete.noFilter}
                            listStyle={styles.autoCompleteListStyle}
                            fullWidth
                            popoverProps={{
                                style: { width: 'auto' },
                                canAutoPosition: true,
                                anchorOrigin: {horizontal: 'left', vertical: 'bottom'},
                                targetOrigin: {horizontal: 'left', vertical: 'top'},
                            }}
                        />
                    </div>
                    <div className="col-xs-2 middle-xs center-xs" style={{ display: 'flex' }}>
                        <IconButton>
                            <ContentAddIcon
                                onClick={() => {
                                    this.addItem();
                                }}
                                color='green'
                            />
                        </IconButton>
                    </div>
                </div>

                <div style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden' }}>
                {
                    filteredList.map((email, indexEmail) => {
                        return (
                            <div key={indexEmail} className="row">
                                <div className="col-xs-10 middle-xs" style={{ display: 'flex', fontSize: '12px' }}>
                                    {email}
                                </div>
                                <div className="col-xs-2 middle-xs center-xs" style={{ display: 'flex' }}>
                                    <IconButton>
                                        <ContentRemoveIcon
                                            onClick={() => {
                                                this.removeItem(email);
                                            }}
                                            color='red'
                                        />
                                    </IconButton>
                                </div>
                            </div>
                        )

                    })
                }
                </div>
                <div className="row">
                    <div className="col-xs-12 center-xs" style={{ display: 'flex' }}>
                        <RaisedButton
                            label='Update black list'
                            primary
                            onClick={this.onUpdateList}
                        />
                    </div>
                </div>
            </div>);
        }
    }
}

export default connect(
    ({}, { selectedUser }) => {
        return {
            selectedUser,
        };
    },
    dispatch => bindActionCreators({
            setUserToBlackList,
        },
        dispatch),
)(BlackList);




// WEBPACK FOOTER //
// ./app/components/Users/BlackAndWhiteLists/BlackList.jsx